import React, { useEffect } from 'react';

import { strings } from '../../localization/strings';
import { useLayout } from '../../hooks/use-layout';

export default function NotFoundPageComponent() {
  const { setPageNotFoundState } = useLayout();

  useEffect(() => {
    setPageNotFoundState(true);

    return () => {
      setPageNotFoundState(false);
    };
  }, [setPageNotFoundState]);

  return (
    <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-blue-800 sm:text-5xl">404</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                {strings().error.pageNotFound.title}
              </h1>
              <p className="mt-1 text-base text-gray-500">{strings().error.pageNotFound.description}</p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <a
                href="/"
                className="inline-flex no-underline items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900"
              >
                {strings().error.pageNotFound.goHome}
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
